export default prefix => {
  // create unique key
  const date = new Date();
  const timestamp = date.toISOString();
  return `${prefix}--${timestamp}`;
};
